import(/* webpackMode: "eager" */ "/home/thescribebank-adminpanel/htdocs/adminpanel.thescribebank.com/app/global-error.tsx");
